// One selector owns ordinary-worker viewport routing. Both the retained-frame
// metadata and worker tile render use this function, so a new specialist can
// be added here without allowing reuse across different loops.
export function isPeriod3Viewport(xRange, yRange) {
  const centerX = 0.5 * (xRange[0] + xRange[1]);
  const centerY = 0.5 * (yRange[0] + yRange[1]);
  return centerX >= -0.17 && centerX <= -0.07 &&
      xRange[1] - xRange[0] <= 0.55 && yRange[1] - yRange[0] <= 0.42 &&
      xRange[0] >= -0.4 && xRange[1] <= 0.2 &&
      ((centerY >= 0.695 && centerY <= 0.795 &&
        yRange[0] >= 0.5 && yRange[1] <= 1.0) ||
        (centerY >= -0.795 && centerY <= -0.695 &&
          yRange[0] >= -1.0 && yRange[1] <= -0.5));
}

export function workerRenderRoute(xRange, yRange, colorParams) {
  if (colorParams?.useMu === false) return 'count';
  if (!colorParams?.juliaC && isPeriod3Viewport(xRange, yRange)) return 'period3';
  return 'ordinary';
}
